const type = {
  typography: {
    min: 12,
    max: 14,
    minScreen: 400,
    maxScreen: 1200,
    scale: {
      min: 1.250,
      max: 1.250,
    },
  },
  // https://www.smashingmagazine.com/2016/05/fluid-typography/
  fluidType: (exp) => {
    return `
      font-size: ${
      type.typography.min * Math.pow(type.typography.scale.min, exp)
    }px;
      @media screen and (min-width: ${type.typography.minScreen}px ) {
        font-size: calc( ${
      type.typography.min * Math.pow(type.typography.scale.min, exp)
    }px + (${
      type.typography.max * Math.pow(type.typography.scale.max, exp)
    } - ${
      type.typography.min * Math.pow(type.typography.scale.min, exp)
    })*(100vw - ${type.typography.minScreen}px)/(${
      type.typography.maxScreen
    } - ${type.typography.minScreen}) );
      }
      @media screen and (min-width: ${type.typography.maxScreen}px ) {
        font-size: ${
      type.typography.max * Math.pow(type.typography.scale.max, exp)
    }px;
      }
      `
  },
  breakpoints: {
    sm: "min-width: 576px",
    md: "min-width: 768px",
    lg: "min-width: 992px",
    xl: `min-width: 1200px`,
  },
}

export const themeOne = {
  colors: {
    color1: '#5301B7',
    color2: '#C6C6F2',
    color3: '#555C27',
    color4: '#8B8C4E',
    color5: '#2A51DD',
    color6: '#839AEB',
    color7: '#b7e73d',
    color8: '#e1e1e1',
    color9: '#000',
  },
  ...type
}

export const themeTwo = {
  colors: {
    color1: '#8C6F4E',
    color2: '#67A6AA',
    color3: '#5E4E8C',
    color4: '#AACE8D',
    color5: '#4E6B8C',
    color6: '#8C4E4E',
    color7: '#8C4E7E',
    color8: '#D1C498',
    color9: '#8B8C4E',
  },
  ...type
}

export const themeThree = {
  colors: {
    color1: '#090040',
    color2: '#2B639D',
    color3: '#B0B2D2',
    color4: '#3E2A0D',
    color5: '#BF3323',
    color6: '#FF9C00',
    color7: '#311A10',
    color8: '#E9ACEA',
    color9: '#FEDEFF',
  },
  ...type
}

export const themeFour = {
  colors: {
    color1: '#186F65',
    color2: '#d22ab6',
    color3: '#B5CB99',
    color4: '#FCE09B',
    color5: '#B2533E',
    color6: '#EBE4D1',
    color7: '#B4B4B3',
    color8: '#26577C',
    color9: '#E55604',
  },
  ...type
}

export const themeFive = {
  colors: {
    color1: '#57375D',
    color2: '#FF3FA4',
    color3: '#FF9B82',
    color4: '#FFC8C8',
    color5: '#27005D',
    color6: '#9400FF',
    color7: '#AED2FF',
    color8: '#E4F1FF',
    color9: '#000',
  },
  ...type
}

export const themeSix = {
  colors: {
    color1: '#116D6E',
    color2: '#321E1E',
    color3: '#4E3636',
    color4: '#CD1818',
    color5: '#454545',
    color6: '#FF6000',
    color7: '#FFA559',
    color8: '#FFE6C7',
    color9: '#3c863c',
  },
  ...type
}

export const themeSeven = {
  colors: {
    color1: '#0079FF',
    color2: '#00DFA2',
    color3: '#F6FA70',
    color4: '#FF0060',
    color5: '#FFB84C',
    color6: '#F266AB',
    color7: '#A459D1',
    color8: '#2CD3E1',
    color9: '#00ff1c'
  },
  ...type
}


export const colorSchemeThemes = [
  themeOne,
  themeTwo,
  themeThree,
  themeFour,
  themeFive,
  themeSix,
  themeSeven,
]